import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/quickbooks/:projectId/disconnect`;

type DisconnectQuickbooksResponse = { status: boolean };

export const disconnectQuickbooks = ({
  projectId,
}: {
  projectId: string | number;
}): Promise<DisconnectQuickbooksResponse> => {
  const URL = generateRoutePath(url, { projectId });
  return axios.post(URL, { projectId }, { showError: false });
};

type UseDisconnectQuickbooksOptions = {
  config?: MutationConfig<typeof disconnectQuickbooks>;
};

export const useDisconnectQuickbooks = ({ config }: UseDisconnectQuickbooksOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: ({ projectId }) => disconnectQuickbooks({ projectId }),
  });
};
